const getChatButtonType = (type = '') => {
  switch (type?.toLowerCase()) {
    case 'secondary':
      return 'secondary'
    default:
      return 'primary'
  }
}

export default getChatButtonType
